function parseIntList(baseList = []) {
  if (Array.isArray(baseList)) {
    return baseList.map(item => parseInt(item, 10)).filter(item => item);
  }
  return [];
}

export default parseIntList;
